import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { HeaderComponent } from './header.component';
import { HeroComponent } from './hero.component';
import { AuthorityComponent } from './authority.component';
import { RiskComponent } from './risk.component';
import { NewsComponent } from './news.component';
import { HowItWorksComponent } from './how-it-works.component';
import { PackComponent } from './pack.component';
import { SegmentsComponent } from './segments.component';
import { MetricsComponent } from './metrics.component';
import { FaqComponent } from './faq.component';
import { CtaFormComponent } from './cta-form.component';
import { FooterComponent } from './footer.component';
import { ModalComponent } from './modal.component';
import { BlogCarouselComponent } from './blog-carousel.component';
import { SimulatorPopupComponent } from './simulator-popup.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    AuthorityComponent,
    RiskComponent,
    NewsComponent,
    HowItWorksComponent,
    PackComponent,
    SegmentsComponent,
    MetricsComponent,
    FaqComponent,
    CtaFormComponent,
    ModalComponent,
    FooterComponent,
    BlogCarouselComponent,
    SimulatorPopupComponent,
  ],
  template: `
    @if (mostrarPopup()) {
      <app-simulator-popup (fechar)="fecharPopup()" (concluido)="onSimuladorConcluido()"></app-simulator-popup>
    }
    <app-header></app-header>
    <app-modal></app-modal>
    <main>
      <app-hero></app-hero>
      <app-authority></app-authority>
      <div class="content-auto">
        <app-risk></app-risk>
      </div>
      @defer (on viewport) {
        <div class="content-auto">
          <app-news></app-news>
        </div>
        <div class="content-auto">
          <app-how-it-works></app-how-it-works>
        </div>
        <div class="content-auto">
          <app-pack></app-pack>
        </div>
        <div class="content-auto">
          <app-segments></app-segments>
        </div>
        <div class="content-auto">
          <app-blog-carousel></app-blog-carousel>
        </div>
        <div class="content-auto">
          <app-faq></app-faq>
        </div>
        <div class="content-auto">
          <app-cta-form></app-cta-form>
        </div>
        <div class="content-auto">
          <app-metrics></app-metrics>
        </div>
      } @placeholder {
        <div style="min-height: 2000px"></div>
      }
    </main>
    <app-footer></app-footer>
  `
})
export class HomeComponent implements OnInit, OnDestroy {
  mostrarPopup = signal(false);

  private popupJaExibido = false;
  private timerId: ReturnType<typeof setTimeout> | null = null;
  private scrollHandler: (() => void) | null = null;
  private exitHandler: ((e: MouseEvent) => void) | null = null;

  ngOnInit() {
    if (sessionStorage.getItem('beetrack_simulador_concluido')) return;

    this.timerId = setTimeout(() => this.abrirPopup(), 12000);

    this.scrollHandler = () => {
      const scrollavel = document.body.scrollHeight - window.innerHeight;
      if (scrollavel > 0 && window.scrollY / scrollavel >= 0.5) {
        this.abrirPopup();
      }
    };
    window.addEventListener('scroll', this.scrollHandler, { passive: true });

    const isDesktop = window.matchMedia('(pointer: fine) and (min-width: 768px)').matches;
    if (isDesktop) {
      this.exitHandler = (e: MouseEvent) => {
        if (e.clientY <= 0) this.abrirPopup();
      };
      document.addEventListener('mouseleave', this.exitHandler);
    }
  }

  ngOnDestroy() {
    this.removerGatilhos();
  }

  private abrirPopup() {
    if (this.popupJaExibido) return;
    if (sessionStorage.getItem('beetrack_simulador_concluido')) return;
    this.popupJaExibido = true;
    this.removerGatilhos();
    this.mostrarPopup.set(true);
  }

  private removerGatilhos() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    if (this.exitHandler) {
      document.removeEventListener('mouseleave', this.exitHandler);
      this.exitHandler = null;
    }
  }

  fecharPopup() {
    this.mostrarPopup.set(false);
  }

  onSimuladorConcluido() {
    this.mostrarPopup.set(false);
  }
}
